( function( $ ) {
	$( document ).ready( function () {
		// Set the date we're counting down to.
		var countDownDate = new Date( $( '.top-line-area #countdown' ).data( 'date' ) ).getTime();
		var now           = new Date( $( '.top-line-area' ).data( 'now' ) ).getTime();
		var container     = $( '.top-line-area #countdown' );

		// Update the count down every 1 second.
		var topLineCountdown = setInterval( function() {

			// Find the distance between now and the count down date.
			var distance = countDownDate - now;
			now          += 1000; // Increment the current time by 1 second.

			// Time calculations for days, hours, minutes and seconds.
			var days    = Math.floor( distance / ( 1000 * 60 * 60 * 24 ) );
			var hours   = Math.floor( ( distance % ( 1000 * 60 * 60 * 24 ) ) / ( 1000 * 60 * 60 ) );
			var minutes = Math.floor( ( distance % ( 1000 * 60 * 60 ) ) / ( 1000 * 60 ) );
			var seconds = Math.floor( ( distance % ( 1000 * 60 ) ) / 1000 );

			if ( 0 >= distance ) {
				clearInterval( topLineCountdown );
				$( '.top-line-area' ).remove();
			} else {
				if ( days < 1 ) {
					container.find( '.days' ).parent().hide();
				} else {
					container.find( '.days' ).text( String( days ).padStart( 2, '0' ) );
				}
				container.find( '.hours' ).text( String( hours ).padStart( 2, '0' ) );
				container.find( '.minutes' ).text( String( minutes ).padStart( 2, '0' ) );
				container.find( '.seconds' ).text( String( seconds ).padStart( 2, '0' ) );
			}
		}, 1000 );
	} );
} )( jQuery );
